import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { BarChart3 } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';

export const AnalyticsCard = ({ settings, updateField }) => {
  const { t } = useLanguage();
  return (
    <Card className="bg-card border-border">
      <CardContent className="p-6">
        <div className="flex items-center gap-2 mb-6">
          <BarChart3 className="w-5 h-5 text-primary" />
          <h2 className="text-lg font-bold">{t('siteSettings.analytics')}</h2>
        </div>
        <p className="text-sm text-muted-foreground mb-4">{t('siteSettings.analyticsHint')}</p>

        <div>
          <Label className="text-sm">{t('siteSettings.gaId')}</Label>
          <Input
            value={settings.google_analytics_id || ''}
            onChange={(e) => updateField('google_analytics_id', e.target.value)}
            placeholder="G-XXXXXXXXXX"
            className="bg-secondary border-border mt-1 font-mono max-w-sm"
            data-testid="ga-id-input"
          />
          <p className="text-xs text-muted-foreground mt-1">{t('siteSettings.gaIdHint')}</p>
        </div>
      </CardContent>
    </Card>
  );
};
